
<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './advertoauth-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      dataForm: {
        auth_code: '',
        state: ''
      }
    }
  },
  created () {
     
      let state = this.$route.query.state
      let auth_code = this.$route.query.auth_code
      if ((state != null || auth_code != null)) {
          this.$http.get(`/sys/advertoauth/getToken?auth_code=` + auth_code + '&state=' + state).then(({data: res}) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.$message({
                  message: this.$t('prompt.success'),
                  type: '授权成功',
                  duration: 500,
                  onClose: () => {
                      this.visible = false
                      this.$router.replace({
                          path: "sys-advertoauth"
                      });
                      /*this.$router.push({
                    path: "sys-advertoauth"
                });*/

                  }
              })
              /*this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.visible = false
            this.$emit('refreshDataList')

          }
        })*/

          }).catch(() => {
          })
      }
  }
}
</script>
